import { render, staticRenderFns } from "./Visualization.vue?vue&type=template&id=37131fd3&scoped=true"
import script from "./Visualization.vue?vue&type=script&lang=js"
export * from "./Visualization.vue?vue&type=script&lang=js"
import style0 from "./Visualization.vue?vue&type=style&index=0&id=37131fd3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37131fd3",
  null
  
)

export default component.exports